var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 588,
    viewBox: "0 0 588 588",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.37 0.650149C84.3125 2.60915 60.2404 11.6201 37.9604 32.2472C21.7944 47.2142 11.0164 65.6751 5.38044 88.0501C0.628444 106.916 0.560446 109.38 0.126446 279.124C-0.271554 434.675 0.173454 468.611 2.86245 487.565C5.06945 503.13 12.9104 523.429 21.7314 536.42C27.2324 544.52 38.8254 556.676 46.7444 562.646C55.3424 569.128 70.1975 576.733 80.6995 580.028C104.312 587.437 117.561 587.861 310.37 587.372C428.569 587.072 472.064 586.649 479.87 585.725C510.698 582.076 532.606 571.975 552.337 552.315C568.246 536.462 577.199 520.516 582.761 498.124C587.05 480.861 587.189 475.398 587.61 308.124C588.103 111.873 587.79 103.114 579.367 77.9192C568.818 46.3632 543.548 20.5272 511.598 8.63315C503.83 5.74115 490.655 2.83015 479.37 1.51215C467.675 0.146148 147.207 -0.626851 122.37 0.650149ZM153.146 116.788C128.345 119.613 111.35 146.091 118.733 170.4C129.88 207.098 179.856 210.84 196.883 176.251C202.395 165.052 202.231 149.92 196.482 139.261C187.588 122.773 171.923 114.649 153.146 116.788ZM361.87 232.119C340.631 236.868 321.979 247.109 309.334 260.963L302.977 267.928L303.08 264.526C303.136 262.655 303.112 255.162 303.026 247.874L302.87 234.624H269.366H235.862L236.116 352.874L236.37 471.124H271.87H307.37L307.87 402.124C308.427 325.316 308.016 329.86 315.519 317.42C322.388 306.03 333.449 299.466 348.636 297.767C355.912 296.953 364.572 297.503 370.016 299.124C379.829 302.047 389.4 309.862 393.852 318.588C398.618 327.93 398.834 331.601 398.853 403.355L398.87 470.586L401.12 471.134C402.357 471.436 418.445 471.557 436.87 471.403L470.37 471.124V388.624V306.124L468.035 298.124C465.165 288.291 457.517 271.939 451.96 263.756C443.382 251.124 424.075 238.512 405.488 233.398C395.898 230.76 371.191 230.035 361.87 232.119ZM122.116 352.874L122.37 471.124H158.87H195.37L195.624 352.874L195.878 234.624H158.87H121.862L122.116 352.874Z",
    fill: "url(#paint0_radial_762_660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_762_660",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(208.559 587.513) rotate(-73.8044) scale(611.791 575.422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8ECF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564246,
    stopColor: "#96C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8ECF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8d4a49222222f2ceeb08159ddb46ded4.svg";
export { ForwardRef as ReactComponent };